import { CollectionEntity } from "@busy-human/gearbox";
export var ChecklistDefinitions;
(function (ChecklistDefinitions) {
    let ChecklistCategory;
    (function (ChecklistCategory) {
        ChecklistCategory["payment"] = "payment";
        ChecklistCategory["passport"] = "passport";
        ChecklistCategory["builderPacket"] = "builderPacket";
        ChecklistCategory["parentBuilderPacket"] = "parentBuilderPacket";
        ChecklistCategory["atHomePacket"] = "atHomePacket";
        ChecklistCategory["parentInfo"] = "parentInfo";
        ChecklistCategory["emergency"] = "emergency";
        ChecklistCategory["allAboutYou"] = "allAboutYou";
        ChecklistCategory["notarizedAuthorizations"] = "notarizedAuthorizations";
        ChecklistCategory["healthDocuments"] = "healthDocuments";
        ChecklistCategory["healthForm"] = "healthForm";
        ChecklistCategory["groupMe"] = "groupMe";
        ChecklistCategory["flight"] = "flight";
        ChecklistCategory["vaccination"] = "vaccination";
        ChecklistCategory["visa"] = "visa";
        ChecklistCategory["builderPrepVideos"] = "builderPrepVideos";
        ChecklistCategory["parentBuilderInfo"] = "parentBuilderInfo";
        ChecklistCategory["parentBackgroundCheck"] = "parentBackgroundCheck";
        ChecklistCategory["parentTraining"] = "parentTraining";
        ChecklistCategory["other"] = "other";
    })(ChecklistCategory = ChecklistDefinitions.ChecklistCategory || (ChecklistDefinitions.ChecklistCategory = {}));
    function resolveModelForRelativeDueDate(relativeDueDate) {
        const [days, token, type] = relativeDueDate.split(" ");
        if (token !== "day" && token !== "days") {
            throw new Error(`Invalid relative due date: ${relativeDueDate}`);
        }
        return {
            days: parseInt(days),
            type: type === "before" ? "before departure" : "after registration"
        };
    }
    ChecklistDefinitions.resolveModelForRelativeDueDate = resolveModelForRelativeDueDate;
    function Default() {
        return {
            name: '',
            description: '',
            completionMethod: 'user-checks-off',
            category: ChecklistCategory.allAboutYou,
            season: '',
            optional: false,
            personApplicability: ['unspecified'],
            tripApplicability: ['unspecified'],
            dueDateType: 'relative',
            dueDateRelative: "1 days after registration",
            modifiedTimestamp: null
        };
    }
    ChecklistDefinitions.Default = Default;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Default();
        }
        async getAllAsMap() {
            return new Map((await this.fetchAll()).dataItems().map(b => ([b.$id, b])));
        }
    }
    ChecklistDefinitions.CollectionClass = CollectionClass;
    ChecklistDefinitions.Collection = new CollectionClass({ path: "/Checklist-Definitions" });
})(ChecklistDefinitions || (ChecklistDefinitions = {}));
//# sourceMappingURL=index.js.map